import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl, FormHelperText } from '@mui/material';

import BaseSelectWithCheckboxes from '../../../../../../shared/components/base-select-with-checkboxes/base-select-with-checkboxes';
import { mapFirmwaresModelToItemLabelModel } from '../../../../../../shared/utils/mapping/mapping.util';
import { useAppSelector } from '../../../../../../store/hooks';
import InputLabel from '../../../../../shared/components/ui/InputLabel';
import withFirmwareOptions from './components/with-firmware-options/with-firmware-options';
import { useFilteredSelectWithCheckboxesOnChange } from './hooks/use-filtered-select-with-checkboxes-on-change.hook';
import { CampaignFirmwaresSelectProps } from './types/campaign-firmwares-select-props.type';

export const CampaignFirmwaresSelect: FunctionComponent<
  CampaignFirmwaresSelectProps
> = (props: PropsWithChildren<CampaignFirmwaresSelectProps>) => {
  const { values, errors, touched, setFieldValue, options, handleBlur } = props;

  const isLoading: boolean = useAppSelector(state => state.root.isLoading);

  const onChange = useFilteredSelectWithCheckboxesOnChange(
    setFieldValue,
    options,
    values.firmwareIds
  );

  return (
    <FormControl
      data-testid="campaign-firmwares-select-form-control"
      classes={{
        root: 'form-control-main',
      }}
      key="campaign-firmwares"
      variant="filled"
      error={touched.firmwareIds && !!errors.firmwareIds}
    >
      <InputLabel id="multiple-checkbox-label-firmwares" required={true}>
        Firmwares
      </InputLabel>

      <BaseSelectWithCheckboxes
        id="firmwareIds"
        key="campaign-firmwares"
        name="firmwareIds"
        onChange={onChange}
        onBlur={handleBlur}
        isLoading={isLoading}
        selectOptions={options.map(mapFirmwaresModelToItemLabelModel)}
        value={
          values.firmwareIds && values.firmwareIds.length
            ? values.firmwareIds
            : []
        }
      />
      {touched.firmwareIds && !!errors.firmwareIds && (
        <FormHelperText>{errors.firmwareIds}</FormHelperText>
      )}
    </FormControl>
  );
};

export default withFirmwareOptions(CampaignFirmwaresSelect);
